export const FALLBACK = 0; // An issue was encountered during execution.
export const ZAPPOS_PLAIN = 1;
export const ZAPPOS_LEGACY_VIP = 2; // Customer was part of our pre-Super Cloud VIP program
export const ZAPPOS_MOBILE_PROMO = 3; // Customer placed an order from a mobile device
export const ZAPPOS_REWARDS_SILVER = 4;
export const ZAPPOS_REWARDS_GOLD = 5;
export const ZAPPOS_REWARDS_PLATINUM = 6;
export const ZAPPOS_REWARDS_ELITE = 7;
export const ZAPPOS_REWARDS_SILVER_AS_GOLD = 8;
export const ZAPPOS_LWA_PLUS_PRIME = 9;
export const ZAPPOS_NEW_VIP = 10;
export const ZAPPOS_FREE_HOLIDAY_SHIPPING = 11;
export const ZAPPOS_PLAIN_NO_VIP_AT_CHECKOUT = 12;
export const ZAPPOS_LWA_PRIME_NO_VIP_AT_CHECKOUT = 13;
export const ZAPPOS_VIP_AT_CHECKOUT = 14;
export const VRSNL_PLAIN = 200;
